import React, { useState, useMemo } from 'react';
import Select from 'react-select';
import { selectStyles } from './Styles';
import { Group, GroupHeading, Option } from './Components';

// Define the MultiSelectCheckbox component
const MultiSelectCheckbox = ({ ...props }) => {
  // State to manage selected options
  const [selectedOptions, setSelectedOptions] = useState([]);
  const selectedCount = selectedOptions?.length;

  //external change of selected options
  useMemo(() => {
    setSelectedOptions(props.value);
  }, [props.value]);

  // Handler for changes in multi-select
  const handleMultiSelectChange = (newlySelectedOptions) => {
    if (props.onChange) {
      props.onChange(newlySelectedOptions);
    }

    setSelectedOptions(newlySelectedOptions);
  };

  // Handler for group selection
  const handleGroupSelect = (groupData, groupValue, checked, selectOnChange) => {
    // Filter currently selected items within the group
    //const selectedItems = groupData.options.filter((option) => selectedOptions.includes(option));
    const selectedItems = groupData.options.filter((option) => {
      return selectedOptions.some((selectedOption) => selectedOption.value === option.value);
    });

    // Filter unselected items within the group
    const unselectedItems = groupData.options.filter(
      (item) => !selectedItems.some((selectedItem) => selectedItem.value === item.value),
    );

    // Update selected options based on the group selection
    if (checked) {
      selectOnChange([...selectedOptions, ...unselectedItems]);
    } else {
      selectOnChange(
        selectedOptions.filter((option) => !selectedItems.some((selectedItem) => selectedItem.value === option.value)),
      );
    }
  };

  // Define default components for the Select component
  const defaultComponents = {
    Option: Option,
    GroupHeading: GroupHeading,
    Group: Group,
  };

  // Render the Select component
  return (
    <Select
      {...props}
      components={defaultComponents}
      options={props.options}
      value={props.value}
      onChange={handleMultiSelectChange}
      isMulti={true}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      styles={{ ...selectStyles, ...props.styles }}
      handleGroupSelect={handleGroupSelect}
      placeholder={
        selectedCount > 0
          ? `${selectedCount} items selected`
          : props.placeholder
          ? props.placeholder
          : 'Select Dataset(s)'
      }
      controlShouldRenderValue={false}
    />
  );
};

export default MultiSelectCheckbox;
